namespace GeniuzPOS.Administration {
    export interface PsPosScreenTypeRow {
        Id?: number;
        PosScreenType?: string;
        PosScreenTypeName?: string;
    }

    export namespace PsPosScreenTypeRow {
        export const idProperty = 'PosScreenType';
        export const nameProperty = 'PosScreenTypeName';
        export const localTextPrefix = 'Administration.PsPosScreenType';
        export const lookupKey = 'Administration.PsPosScreenType';

        export function getLookup(): Q.Lookup<PsPosScreenTypeRow> {
            return Q.getLookup<PsPosScreenTypeRow>('Administration.PsPosScreenType');
        }
        export const deletePermission = '1POSBASE:โปรไฟล์ของกิจการ:พารามิเตอร์ระบบ:Modify';
        export const insertPermission = '1POSBASE:โปรไฟล์ของกิจการ:พารามิเตอร์ระบบ:Modify';
        export const readPermission = '1POSBASE:โปรไฟล์ของกิจการ:พารามิเตอร์ระบบ:View';
        export const updatePermission = '1POSBASE:โปรไฟล์ของกิจการ:พารามิเตอร์ระบบ:Modify';

        export declare const enum Fields {
            Id = "Id",
            PosScreenType = "PosScreenType",
            PosScreenTypeName = "PosScreenTypeName"
        }
    }
}
